// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-error{color:#DD524C;margin-bottom:0.5rem}\n", ""]);
// Exports
module.exports = exports;
